import React, { useMemo } from 'react';
import { Chip, Box, Button, Paper } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { CHART_COLORS } from '../../constants/layout';

const CategoryLegend = ({ categoryData, hiddenCategories, toggleCategoryVisibility, setHiddenCategories }) => {
  const allSelected = useMemo(() => hiddenCategories.length === 0, [hiddenCategories]);
  const noneSelected = useMemo(() => hiddenCategories.length === categoryData.length, [hiddenCategories, categoryData]);

  const toggleSelectAll = () => {
    if (allSelected) {
      setHiddenCategories(categoryData.map(category => category.category));
    } else {
      setHiddenCategories([]);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
        <Button
          variant={allSelected ? 'contained' : 'outlined'}
          size="small"
          onClick={toggleSelectAll}
          startIcon={allSelected ? <VisibilityIcon /> : <VisibilityOffIcon />}
          sx={{ mr: 1 }}
        >
          {allSelected ? 'Ocultar Todas' : 'Mostrar Todas'}
        </Button>

        {categoryData.map(({ category }, index) => {
          const isHidden = hiddenCategories.includes(category);
          const color = CHART_COLORS[index % CHART_COLORS.length];

          return (
            <Chip
              key={category}
              label={category}
              onClick={() => toggleCategoryVisibility(category)}
              variant={isHidden ? 'outlined' : 'filled'}
              sx={{
                bgcolor: isHidden ? 'transparent' : color,
                color: isHidden ? 'text.secondary' : '#fff',
                borderColor: color,
                opacity: isHidden ? 0.5 : 1,
                '&:hover': {
                  bgcolor: isHidden ? `${color}20` : color,
                  opacity: 1,
                },
              }}
            />
          );
        })}
      </Box>
    </Paper>
  );
};

export default CategoryLegend;
